$milis_log_demo $mol_example_small
	title \$milis_log
	sub /
		<= Layout $mol_list rows /
			<= Info $mol_text text \
				\# Быстрое логирование функций
				\
			<= Input_label $mol_labeler
				title \Откройте консоль и начните вводить текст
				content /
					<= Input $mol_string
						value? <=> input_value? \
			<= Length_label $mol_labeler
				title \Реактивно связанное значение - длина строки
				content /
					<= Input_length $mol_paragraph
						title <= input_length \Длина строки:
			- <= Example_code2 $mol_textarea value? <=> value? \
			<= Example_label $mol_labeler
				title \Пример кода
				content /
					<= T $mol_textarea
						value? <=> v? \
							\@$milis_log
							\@$mol_mem
							\input_value(next?: string): string {
							\    return next || ''
							\}
			<= Image $mol_text text \![image](https://github.com/user-attachments/assets/4022a849-c1ea-4def-88a5-d80a531659b8)
	tags /
		\log
		\console
		\info
		\debug
	aspects /
		\Widget/Log
